module.exports = __webpack_public_path__ + "static/ceramic08-8297d097e6e22198019b68fa01cff52c.jpg";